import Storage from '../Storage'
import { create } from './axios/factory'

type RequestParams = {
  path: string
  params?: object
  headers?: object
}

const StackAPI = () => {
  const activeRole = Storage().getActiveRole()
  const axios = create({
    initialHeaders: {
      'X-Current-Partner': activeRole?.id
    }
  })

  const get = async <T>({ path, params, headers }: RequestParams) =>
    axios.get<T>(path, { params, headers })

  const put = async ({ path, params, ...config }: RequestParams) =>
    axios.put(path, params, config)

  const patch = async ({ path, params, ...config }: RequestParams) =>
    axios.patch(path, params, config)

  const post = async ({ path, params, ...config }: RequestParams) =>
    axios.post(path, params, config)

  const destroy = async ({ path, params, headers }: RequestParams) =>
    axios.delete(path, { data: params, headers })

  return {
    get,
    put,
    patch,
    post,
    destroy
  }
}

export default StackAPI
